import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';
import { getImageAtSize } from '../../lib/utils';

import { useTheme, useThemeClassName } from '../../contexts/ThemeContext';

import styles from '../../../styles/splashes/iga-noel-splash.module.scss';

import bonichoixGifts from '../../../img/iganoel2024/bonichoix_gifts.png';
import scenePointsEn from '../../../img/iganoel2024/scene_points_en.svg';
import scenePointsFr from '../../../img/iganoel2024/scene_points_fr.svg';
import traditionGifts from '../../../img/iganoel2024/tradition_gifts.png';

const gifts = {
    tradition: traditionGifts,
    bonichoix: bonichoixGifts,
};

const propTypes = {
    tagline: PropTypes.string,
    subtitle: PropTypes.string,
    complete: PropTypes.bool,
    image: AppPropTypes.image,
    offer: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    tagline: null,
    subtitle: null,
    complete: true,
    image: null,
    offer: null,
    className: null,
};

function IgaNoelSplash({ image, tagline, subtitle, offer, complete, className }) {
    const { locale } = useIntl();
    const { variant, isVariant } = useTheme();
    const themeClassName = useThemeClassName(styles);
    const { url: imageUrl = null } = getImageAtSize(image) || {};
    return (
        <div className={classNames([styles.container, themeClassName, className])}>
            <div className={styles.splash}>
                <div className={styles.imageContainer}>
                    <img
                        src={imageUrl}
                        className={classNames([styles.image, styles.logo])}
                        alt="L'avent gourmand"
                    />
                    <img
                        src={gifts[variant.join('')]}
                        className={classNames([styles.image, styles.logo])}
                        alt="Cadeaux"
                    />
                </div>
                <div className={styles.taglineContainer}>
                    {tagline !== null ? (
                        <div
                            className={styles.tagline}
                            dangerouslySetInnerHTML={{ __html: tagline }}
                        />
                    ) : null}
                    {isVariant('tradition') ? (
                        <img
                            src={locale === 'fr' ? scenePointsFr : scenePointsEn}
                            className={styles.scenePoints}
                        />
                    ) : null}
                </div>
            </div>
        </div>
    );
}

IgaNoelSplash.propTypes = propTypes;
IgaNoelSplash.defaultProps = defaultProps;

export default IgaNoelSplash;
